import {
  useGetApplicableRecProgramsQuery,
  useGetApplicableTrackingSystemsQuery,
  useGetCompanyRolesQuery,
  useGetCountriesQuery,
  useGetCreditProfilesQuery,
  useGetIsosQuery,
  useGetNegativePricingQuery,
  useGetOfferStatusesQuery,
  useGetPerformanceGuaranteeMethodsQuery,
  useGetPriceUnitsQuery,
  useGetProductTypesQuery,
  useGetRecDeliveryMethodologiesQuery,
  useGetReferenceUserRolesQuery,
  useGetRegulatoryStatusesQuery,
  useGetSettlementIndexesQuery,
} from '@/store/api/referenceApi';

export const useLoadReferenceData = () => {
  useGetReferenceUserRolesQuery();
  useGetRegulatoryStatusesQuery();
  useGetCreditProfilesQuery();
  useGetCompanyRolesQuery();
  useGetCountriesQuery();
  useGetOfferStatusesQuery();
  useGetProductTypesQuery();
  useGetIsosQuery();
  useGetSettlementIndexesQuery();
  useGetNegativePricingQuery();
  useGetApplicableRecProgramsQuery();
  useGetRecDeliveryMethodologiesQuery();
  useGetPerformanceGuaranteeMethodsQuery();
  useGetApplicableTrackingSystemsQuery();
  // Loaded up front so the first grid to show a price doesn't render it without its unit.
  useGetPriceUnitsQuery();
};
